import React from "react";
import { Route, Routes } from "react-router-dom";
import { I18nextProvider } from 'react-i18next';
import Landing from "./page/Landing";
import SignUp from "./page/signup_page";
import LogIn from "./page/login_page";
import Home from "./page/Home";
import Shop from "./page/ShoppingPage";
import Promotion from "./page/PromotionPage";
import Blog from "./page/BlogPage";
import Contact from "./page/ContactPage";
import Layout from "./components/Layout";
import BlogDetail from "./components/BlogDetail";
import ForgotPassword from "./page/forgot_password";
import Favorites from "./components/Favorites";
import Cart from "./components/CartPage";
import CheckOut from "./components/CheckOut";
import Payment from "./components/Payment";
import ProfilePage from "./page/ProfilePage";
import MenPerfume from "./page/MenPerfume"; // Create this component
import WomenPerfume from "./page/WomenPerfume"; // Create this component
import Unisex from "./page/Unisex"; // Create this component
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./index.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import i18n from "./components/i18n";
import NetworkStatus from "./data/NetworkStatus";
import OrderHistory from "./components/Order_History";


const App = () => {
  return (
    <div className="routing">
      <I18nextProvider i18n={i18n}>
        <NetworkStatus />
        <Layout>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/home" element={<Home />} />
            <Route path="/men-perfume" element={<MenPerfume />} />
            <Route path="/women-perfume" element={<WomenPerfume />} />
            <Route path="/unisex" element={<Unisex />} />
            <Route path="/blogs" element={<Blog />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/login" element={<LogIn />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/blog/:id" element={<BlogDetail />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/payment" element={<Payment />} />
            <Route path="/order-history" element={<OrderHistory />} />
          </Routes>
        </Layout>
      </I18nextProvider>
    </div>
  );
};

export default App;